import { screenMaxWidths } from "./screenWidth";

export const responsive = {
    superWideScreen: {
        breakpoint: { max: screenMaxWidths.superWideScreen, min: screenMaxWidths.wideScreen },
        items: 5,
        slidesToSlide: 5
    },
    wideScreen: {
        breakpoint: { max: screenMaxWidths.wideScreen, min: screenMaxWidths.desktop },
        items: 4,
        slidesToSlide: 4
    },
    desktop: {
        breakpoint: { max: screenMaxWidths.desktop, min: screenMaxWidths.tablet },
        items: 3,
        slidesToSlide: 3
    },
    tablet: {
        breakpoint: { max: screenMaxWidths.tablet, min: screenMaxWidths.mobile },
        items: 2,
        slidesToSlide: 2
    },
    mobile: {
        breakpoint: { max: screenMaxWidths.mobile, min: 0 },
        items: 1,
        slidesToSlide: 1
    }
};